import React from 'react'

const Input = (props) => {
    const { label, error, symbol, className, label2, ...rest } = props

    return (
        <div className='mb-3'>
            <div className='flex gap-x-1 items-center'>
                <label className='block mb-1'>{label} </label>
                {
                    label2 &&
                    <label className='text-xs'> ({label2}) </label>
                }

            </div>

            <div className='relative'>
                <input className={`border px-2 py-1 w-full outline-blue-700 rounded-md shadow-md pr-3 appearance-none ${className}`} {...rest} />
                <span className='absolute inset-y-0 right-0 flex items-center pr-2'>{symbol}</span>
            </div>

            {error && <label className='text-red-700 text-sm'>{error} </label>}
        </div>
    )
}

export default Input